import { render, staticRenderFns } from "./OrderReportListDesktop.vue?vue&type=template&id=1d292dc5&scoped=true"
import script from "./OrderReportListDesktop.vue?vue&type=script&lang=ts"
export * from "./OrderReportListDesktop.vue?vue&type=script&lang=ts"
import style0 from "./OrderReportListDesktop.vue?vue&type=style&index=0&id=1d292dc5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../Yobo/qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d292dc5",
  null
  
)

export default component.exports